import React from 'react';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 02/04/18
 */

import English from './English';
import Indonesia from './Indonesia';

const GoPay = props => {
  switch (props.language) {
    case 'EN':
      return <English />;
    case 'ID':
      return <Indonesia />;
  }
};

export default GoPay;
